/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React ,{useState,useEffect} from "react";
import { Redirect, Switch, Route } from "react-router-dom";
// import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { GetCookies } from "../_metronic/_helpers/Cookies";
import axios from "axios"
import { BASE_URL ,NODE_API_URL,REACT_BASE_URL} from "./../env_config"
import languages from '../_metronic/_helpers/languages.json'
import { PaymentSuccessNew } from "../_metronic/_partials/checkout/PaymentSuccessNew";
import { PaymentFailedNew } from "../_metronic/_partials/checkout/PaymentFailedNew";
import Cookies from "js-cookie"
import getSymbolFromCurrency from "currency-symbol-map";
import {useLocation} from 'react-router-dom'
import { useDispatch } from "react-redux";
import * as plan from "../redux/commonRedux/planRedux";

export function Routes(props) {

  const location = useLocation();
  const dispatch = useDispatch();

  const [localstored,setLocalStored] = useState(false)
  const [paymentgateway,setPaymentGateway] = useState(false)
  const [isAuthorized,setAuth] = useState(true)
  const [isprofilecomplete,setProfileComplete] = useState(false)
  const [userinfo,setUserInfo] = useState({})
  const [language,setLanguage] = React.useState("en")
  const [conversionrate,setConversionRate] = useState(1)
  const [symbol,setSymbol] = useState("$")
  const [symbolname,setSymbolName] = useState("USD")
  const [conversioncookies,setConversionCookies] = useState(false)
  // const { isAuthorized } = useSelector(
  //   ({ auth }) => ({
  //     isAuthorized: auth.user != null,
  //   }),
  //   shallowEqual
  // );


  useEffect(() => {
    
    // let resData = %7B%22id%22%3A%2252027%22%2C%22fname%22%3A%22Divyang%22%2C%22lname%22%3A%22Patel%22%2C%22cname%22%3A%22Divyang%20%20Testing%22%2C%22mail%22%3A%22divyang%40diamondsoncall.com%22%2C%22mobile%22%3A%228975461230%22%2C%22address%22%3A%22808%20York%20Mills%20Rd%2C%22%2C%22default_currency%22%3A%22CAD%22%2C%22v_customer%22%3A%221%22%2C%22country%22%3A%22usa%22%2C%22shipping_email%22%3A%22test%40gmail.com%22%7D
    GetCookies("BaseUrl").then(response => {
      if(response){
        let thisDomain = ["http://localhost:3000/","https://staging.global.diamondsupload.com/","https://makalu.diamondsoncall.com/","https://staging.eu.diamondsupload.com/","https://eu.diamondsoncall.com/"]
        // let resDomain = JSON.stringify(response)
        // console.log("thisDomain",thisDomain)
        // console.log("resDomain",response)
        // console.log(window.location.origin,"ORIGIN")
        let origin = window.location.origin
        if (!thisDomain.includes(response) || `${origin}/` !== response){
            window.location.replace(`${response}dashboard`)
        }
      }
    })
    // let resData = {"CustomerId":52263,"CompanyName":"Test3","EMail":"dikoges397@xtrempro.com","ContactNo":"+244 1212121","CompanyAddress":"surattest","SalesPerson":"test account","Currency":"AUD","CustomerType": 7,"Country":"India"}
    // let currencyData = [{"CurrencyCd":"INR","Currency":"India Ruppee","ConversionRate":81.72}]
    // localStorage.setItem("C_id",-1)
    // localStorage.setItem("userData", JSON.stringify(resData))
    // localStorage.setItem("userCurrency", JSON.stringify(currencyData))
    // {"id":"50022","cname":"Test2","fname":"anita","lname":"hugley","mail":"ios23user@gmail.com","invoiceemail":"dikoges397@xtrempro.com","mail1":"","mobile":"+91 9316635770","password":"0e7517141fb53f21ee439b355b5a1d0a","passport_id":"123123123","passport_file":"152.pdf","work_profile":"ceo","reset_password_token":"","roomno":null,"floor":null,"b_no":null,"street":null,"area":"","address":"626 griffin street phoenix, az 85017","secaddress":"626 griffin street phoenix, az 85017","city":"surat","state":"","country":"India","com_zip":"395007","website":"","birthdate":null,"skype":null,"com_reg_no":"100000000","com_reg_doc":"151.pdf","nature_buss":"jewelry manufacture","buss_esta_date":"2021-02-02","director_name":"mansi patel","directory_contact":"+1 342342342","shipping_phone":"+1435435435345","shipping_email":"anitazhugley@armyspy.com","company_tax":"","port_discharge":"","port_of_discharge":"India","importref":"","contact1":"","contact2":"+1435435435345","fax":"+1 345345","repnet_id":"","discount":"0","lab_discount":"0","send_weekly_mail":"0","mail_status":"0","weekly_mail_status":"0","created_date":"2021-12-07 15:45:36","created_by":"13","type":"","company_name":"","lab_company_name":"","status":"0","shipping_charge":"0","shipping_address":"<p>anita testing<br>626 griffin street phoenix, az 85017, 626 griffin street phoenix, az 85017<br>surat, 395007<br>India<\/p>","comment":"\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t","cus_tags":"","api_pass":"","is_deleted":"0","is_approved":"1","verify_email_token":"","is_verify":"1","v_customer":"3","api":"1","api_key":"","ap_created_date":"0000-00-00 00:00:00","api_test_mode":"OFF","api_test_key":"","aptest_created_date":"2021-12-22 16:26:13","api_live_mode":"0","supplier_api_request":"0","feed_type":"API","on_off":"1","app_auth_token":"","device_token":"","notificatioin_read_status":"1","notificatioin_status":"0","notification_all":"1","notifiaction_confirm_diamond":"1","notifiaction_invoice":"1","notifiaction_shipment":"1","notifiaction_email_confirm_diamond":"1","notifiaction_email_invoice":"1","notifiaction_email_shipment":"1","source":"","username":"","kyc_status":"KYC_APPR","billing_address":"","api_id":null,"kyc_apprv_by":null,"kyc_apprv_date":null,"sales_level_1":"13","sales_level_2":null,"sales_level_3":null,"sales_level_4":null,"show_me_check":"1","dashboard_check_box":"1","service_charge_discount":"0","in_out_bound":null,"default_currency":"INR"}
    GetCookies("cust_auth_token").then(response => {
      // console.log("Routes call")
      // console.log(window.location.origin)
      // setAuth(true)
        if(response){
              axios({
                method: "GET",
                url: `${NODE_API_URL}/INTL/profile-validator`,
                headers: { 
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
                }
              }).then((res) => {
                if (res && res.data && res.data.success) {
            let resData = {"CustomerId":res.data.data.userdata.id,"fname":res.data.data.userdata.fname,"lname":res.data.data.userdata.lname,"CompanyName":res.data.data.userdata.cname,"EMail":res.data.data.userdata.mail,"ContactNo":res.data.data.userdata.mobile,"CompanyAddress":res.data.data.userdata.address,"SalesPerson":"test account","Currency":res.data.data.userdata.default_currency,"CustomerType":res.data.data.userdata.v_customer,"Country":res.data.data.userdata.country,"shipping_email":res.data.data.userdata.shipping_email}
            let currencyData = [{"CurrencyCd":"AUD","Currency":"Australian Dollar","ConversionRate":1.466031}]
              localStorage.setItem("C_id",-1)
              localStorage.setItem("userData", JSON.stringify(resData))
              localStorage.setItem("userCurrency", JSON.stringify(currencyData))
              setLocalStored(true)
              setAuth(true)
                    setProfileComplete(res.data.data.isvalidprofile)
                    setUserInfo(res.data.data.userdata)
                  //   if(res.data.data.userdata.v_customer.toString() === "11"){
                  //     localStorage.clear()
                  //     var cookies = document.cookie.split(";");
                  // for(var i=0; i < cookies.length; i++) {
                  //   if(cookies[i] && !cookies[i].includes("view")){
                  //     var equals = cookies[i].indexOf("=");
                  //     var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                  //   }
                  // }
                  //     window.location.replace(`${BASE_URL}/login/logout`);
                  //     setAuth(false)
                  //   }
                    GetCookies("conversionrates").then(responseconversion => {
                      if(res.data.data.userdata.websitecurrency && responseconversion){
                        const findconv = JSON.parse(responseconversion)[0][res.data.data.userdata.websitecurrency]
                        setConversionRate(findconv)
                        const currencyCode = res.data.data.userdata.websitecurrency.split('_')[1].toUpperCase()
                        setSymbolName(currencyCode)
                        setSymbol(getSymbolFromCurrency(currencyCode))
                      }
                    })
                }
              }).
              catch(error => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                  var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                  if(cookies[i] && !cookies[i].includes("view")){
                    var equals = cookies[i].indexOf("=");
                    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                  }
                }
                setAuth(false)
                window.location.replace(`${BASE_URL}/logout`);
              }
              })

              // axios({
              //   method: "POST",
              //   url: NODE_API_URL + "/INTL/firstTimezone",
              //   headers: { "Content-Type": "application/json" },
              //   data: {
              //     "id":resData.CustomerId,
              //     "timezone":Intl.DateTimeFormat().resolvedOptions().timeZone
              //   },
              // }).then((res) => {
                
              // });

          GetCookies("sales_person").then(salesperson => {
            if (salesperson === "1") {
              setTimeout(() => {
                localStorage.clear()
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                  if(cookies[i] && !cookies[i].includes("view")){
                    var equals = cookies[i].indexOf("=");
                    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                  }
                }
                window.location.replace(`${BASE_URL}/logout`);
              }, 300000)
            }
          })
        }
        else{
          if(window.location.pathname !== "/paymentsuccess" && window.location.pathname !== "/paymentfailed"){
             window.location.replace(`${BASE_URL}/logout`);
             setAuth(false)
          }
          else{
            setPaymentGateway(true)
          }
        }
    })
    GetCookies("language").then(response => {  
      if(response){
          setLanguage(response)
      }
  })
},[conversioncookies])
  useEffect(() => {
    // console.log(window.location.pathname,"window.location.href")
    if (window.location.pathname === '/search-result/N' || window.location.pathname === '/search-result/L' || window.location.pathname === '/search-grid/N' || window.location.pathname === '/search-grid/L' || window.location.pathname === '/search-result/stock-search' || window.location.pathname === '/search-grid/stock-search') {
      // setDisableDropdown(true)
    }
    else {
      sessionStorage.removeItem("pageReloaded")
    }
  }, [window.location.href])

  function fetchPlanFeatures(cancelToken){
      axios({
        method: "GET",
        url: `${NODE_API_URL}/INTL/fetch-plan-features`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
        },
        cancelToken: cancelToken,
      })
      .then(function(res) {
        if(res && res.data && res.data.success){
          dispatch(plan.actions.setFeatures(res.data.data));
        }
        else{
          localStorage.clear();
          window.location.replace("/")
        }
      })
      .catch((error) => {
        if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          setAuth(false)
          window.location.replace(`${BASE_URL}/logout`);
        }
      });
    }

  useEffect(()=>{
      const source = axios.CancelToken.source();
      fetchPlanFeatures(source.token)

      return () => {
        source.cancel("Component unmounted: cancel pending request");
      };
    },[location])

  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        localstored? <Layout language={languages[language]} userinfo={userinfo} conversionrate={conversionrate} symbolname={symbolname}>
          <BasePage localstored={localstored} language={languages[language]} conversionrate={conversionrate} symbol={symbol} isprofilecomplete={isprofilecomplete} userinfo={userinfo} dataFetchedRef={props.dataFetchedRef} symbolname={symbolname} logStoredRef={props.logStoredRef} setConversionCookies={setConversionCookies} conversioncookies={conversioncookies} paymentSuccessNewRef={props.paymentSuccessNewRef}/>
        </Layout> :""
      )}
      {paymentgateway?
      <>
      <Route path="/paymentsuccess" component={() => <PaymentSuccessNew language={languages[language]} userinfo={userinfo} dataFetchedRef={props.dataFetchedRef}/>}/>
      <Route path="/paymentfailed" component={() => <PaymentFailedNew language={languages[language]} userinfo={userinfo}/>}/>
      </>
      :""}
    </Switch>
  );
}